// extracted by mini-css-extract-plugin
export default {"container":"Xc","header":"Yc","logodesktop":"Zc","logomobile":"ae","imgcontainer":"be","slidercontainer":"ce","slick-slider":"ee","slick-initialized":"fe","sliderbox":"ge","headline":"he","mainheadline":"ie","capitalize":"je","desc":"ke","descitalic":"le","desccenter":"me","descborder":"ne","subdesc":"oe","welcomeslide":"pe","desccard":"qe","img":"re","button":"se","buttonskip":"te","customPosition":"ue"};
    if(module.hot) {
      // 1738064240653
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  